import React, { useEffect, useState } from 'react';
import { Row } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars-2';
import styleClasses from '../../Header/Header.module.scss';
import UpsellItemCard from './UpsellItemCard';
import SkeltonLoader from '../../SkeltonLoader/SkeltonLoader';
import SkeletonLoaderForHeadings from '../../SkeltonLoader/SkeletonLoaderForHeadings';
import { useLocation } from 'react-router-dom';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';
interface IUpselItemList {
  data: any;
  cart: any;
  fetchUpsell: () => void;
  isFetchingUpsell: boolean;
  syncCart: () => any;
}

const UpsellItemsLists: React.FC<IUpselItemList> = (props) => {
  const { data, isFetchingUpsell } = props;

  const [showUpsell, setShowUpsell] = useState(true);
  const location = useLocation();
  const isItMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2();
  useEffect(() => {
    if (isFetchingUpsell) return;
    if (data?.length <= 0) {
      setShowUpsell(false);
    } else {
      setShowUpsell(true);
    }
  }, [isFetchingUpsell, data]);

  return (
    showUpsell && (
      <React.Fragment>
        <div className={`${styleClasses.other_products_wrap} ${isDesignV2 ? styleClasses.other_products_wrap_mobile_designv2 : ''}`}  >
          <h4 className={` font-Cls lh-normal ls-normal mb-3 ${isDesignV2 ? 'f-sm-s22 f-w4 clr-dark-grey ls-05' :  'f-s22 f-sm-s16'}`}>
            {data?.length > 0 ? data[0].header : <SkeletonLoaderForHeadings/>} 
          </h4>
          {isFetchingUpsell ? (
            <div className="d-flex justify-content-center">
              <SkeltonLoader />
              <SkeltonLoader />
              <SkeltonLoader />
            </div>
          ) : (
            <Row className={`flex-nowrap ${styleClasses.suggestion_row} ${isDesignV2 ? `pt-0 ${styleClasses.suggestion_row_mobile_designv2}` : 'pt-1'}`}>
              <Scrollbars
                className={styleClasses.other_products_Scrollbar + ' mb-mb-4'}
                renderThumbHorizontal={(props) => (
                  <div {...props} className={styleClasses.Scrollbar_thumb} />
                )}
                renderView={(props) => (
                  <div {...props} className={styleClasses.Scrollbar_view} />
                )}
              >
                {data?.map((item, index: number) => (
                  <React.Fragment key={item?.id}>
                    <UpsellItemCard
                      key={item?.id}
                      upSellItem={item}
                      btnText={'Add'}
                      trackYouMightLike
                    />
                  </React.Fragment>
                ))}
              </Scrollbars>
            </Row>
          )}
        </div>
        <hr className="shadow-divider mb-4 border-0" />
      </React.Fragment>
    )
  );
};

export default UpsellItemsLists;
